import React from 'react';
import '../css/About.scss';
import DP from "../Images/DP.jpg"
import Skills from './Skills';
import { motion } from "framer-motion"
const About = () => {
  const motionInnerDivs = {
    initial: {
      opacity: 0,
      scale: 0,
    },
    whileInView: {
      opacity: 1,
      scale: 1,
    }
  }
  return (
    <> <motion.div className="aboutComp">
      <motion.div initial={{ opacity: 0, x: -100, overflow: 'hidden' }} whileInView={{ opacity: 1, x: 0, transitionDelay: 1 }} className="aboutinner">
        <motion.div {...motionInnerDivs} className="cardLeft">
          <div className="dp-info">
            <img src={DP} alt="" />
            <h2>Asad <span>Ansari</span></h2>
            <span>WEB DEVELOPER</span>
          </div>
          <div className="connections">
            <button>INFO</button>
            <span><i className="fa-solid fa-location-arrow"></i>Delhi,INDIA</span>
            <span><i className="fa-regular fa-envelope"></i>thenightowlprogrammer@gmail.com</span>
            <span><i className="fa-brands fa-github"></i>asadansari8840</span>
            <span><i className="fa-brands fa-instagram"></i>thenightowlprogrammer</span>
          </div>
        </motion.div>
        <motion.div {...motionInnerDivs} className="cardRight">
          <div className="aboutMe-section">
            <i className="fa-regular fa-user"></i><span>About Me</span>
            <hr className='style-one ' />
            <p>Hi i'm Asad a designer and developer , who creates user-friendly web apps for smooth user experience,currently working on React Js (a javascript framework) for creating Single Page Application websites and also upskilling on backend languages like NodeJS and Express and also deals with the databases like MySql and MongoDB. As a developer i hardly try to produce a cleaner code with no errors and bugs ! </p>
          </div>
          <div className="education-section">
            <i className="fa-solid fa-book"></i><span>Education</span>
            <hr className='style-one ' />
            <ul>
              <li>Bachelors's in Computer Application - <span>Jamia Hamdard University,New Delhi</span></li>
              <li>Senior Secondary Education - <span>Kendriya Vidyalaya Sangathan</span></li>
              <li>Web Developement Training and Certification from <span>Cetpa Infotech, Noida</span></li>
            </ul>
          </div>
          <div className="experience-section">
            <i className="fa-solid fa-screwdriver-wrench"></i><span>Skills</span> <hr className='style-one ' />
            <div>
              <ul>
                <span>Frontend</span>
                <li>HTML</li>
                <li>CSS</li>
                <li>JavaScript</li>
                <li>React Js</li>
              </ul>
              <ul>
                <span>Backend</span>
                <li>NodeJs</li>
                <li>Express(Nodejs Framework)</li>
                <li>PHP</li>
                <li>MongoDB</li>
              </ul>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </motion.div>
      <hr className="style-one"></hr>
    </>
  )
}

export default About